import styled from 'styled-components';

export const Form = styled.form`
    padding: 24px;
`;

export const Intro = styled.div`
    display: flex;
    justify-content: space-between;

    div {
        display: flex;
        gap: 1rem;

        h2 {
            color: #262d3c;
            font-size: 500;
        }
    }
`;

export const InputContainer = styled.div`
    width: 600px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-top: 8px;

    div {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }
`;

export const LabelInterventionProtocol = styled.label`
    color: #000000;
    font-weight: 600;
    line-height: 16px;
    font-size: 12px;
`;

export const ButtonsDeleteContainer = styled.section`
    padding-top: 1.5rem;
    display: flex;
    gap: 2rem;
`;

export const ButtonAddProtocolContainer = styled.div`
    padding-top: 1rem;
    display: flex;
    justify-content: flex-end;
`;

export const ButtonNewProtocol = styled.div`
    padding-top: 3rem;
    display: flex;
    gap: 2rem;
`;

export const TableSection = styled.section`
    display: flex;
    flex-direction: column;
    > div {
        display: flex;
    }
`;

export const TableRow = styled.tr`
    cursor: none;

    &.body {
        border-top: 1px solid #d9d9d9;
    }

    &.pointer {
        cursor: pointer;
    }
`;

export const TableData = styled.td`
    cursor: default;
    font-style: normal;
    font-weight: 500;
    font-size: 0.7rem;
    line-height: 1.5rem;
    letter-spacing: 0.02em;
    text-align: left;
    color: #7b7b7b;
    padding: 0.5rem 0 0;

    &:first-child {
        padding-left: 16px;
    }
`;

export const ContainerTab = styled.div`
    width: 800px;
`;
